import {
  ResponsiveLine,
  LineProps,
  PointTooltipProps,
  Datum,
} from "@nivo/line";
import { COLORS } from "styles/colors";
import LineChartTooltip from "./LineChartTooltip";
import { useAppSelector } from "redux/hooks";

export const defaultAxisLeft: any = {
  tickSize: 5,
  tickPadding: 5,
  tickRotation: 0,
  legend: null,
  legendOffset: -40,
  legendPosition: "middle",
  format: (e: any) => Math.floor(e) === e && e,
};

const formatLeft = (e: any) => {
  return e >= 9999 ? "9999+" : Math.floor(e) === e && e;
};

export const formattedLineChartData = (data: { x: string; y: number }[]) => {
  const tempData = data.map((point: any) => {
    return {
      ...point,
      y: point.y >= 9999 ? 9999 : point.y,
    };
  });

  return tempData;
};

const getTickValues = (data: Datum[]) => {
  //데이터가 없을때 빈 배열 반환
  if (!data.length || !data[0].data.length) {
    return [];
  }

  const allValues = data[0].data.map((d: any) => d.y);
  const maxValue = Math.max(...allValues);
  const minValue = Math.min(...allValues);

  // min과 max가 같을때 값을 5개 추가
  if (minValue === maxValue) {
    return Array.from({length: data.length}, (_, i) => minValue + i);
  }

  const effectiveMax = maxValue > 9999 ? 9999 : maxValue;
  const step = Math.max(1, Math.ceil((effectiveMax - minValue) / (data.length - 1)));

  const ticks = Array.from({ length: data.length }, (_, i) => minValue + i * step);

  if (maxValue > 9999) {
    ticks[ticks.length - 1] = 9999; // Replace last tick with 9999 instead of pushing
  }

  return ticks;
};

export default function LineChart(props: LineProps): JSX.Element {
  const themeMode = useAppSelector((state) => state.theme.theme);
  const color = themeMode === "light" ? COLORS.BLACK : COLORS.WHITE;
  return (
    // <div style={{width:"95%", height:"100%"}}>
    <ResponsiveLine
      margin={{ top: 30, right: 80, bottom: 90, left: 60 }}
      xScale={{ type: "point" }}
      yScale={{
        type: "linear",
        min: 0,
        max: "auto",
        stacked: true,
        reverse: false,
      }}
      // yFormat=" >-.2f"
      axisTop={null}
      axisRight={null}
      axisBottom={{
        tickSize: 5,
        tickPadding: 5,
        tickRotation: 45,

        legendOffset: 36,
        legendPosition: "middle",
      }}
      axisLeft={{
        tickSize: 5,
        tickPadding: 5,
        tickRotation: 0,
        legend: null,
        legendOffset: -40,
        legendPosition: "middle",
        format: (e) => formatLeft(e),
        tickValues: getTickValues(props.data),
      }}
      colors={{
        datum: "color",
      }}
      lineWidth={1}
      tooltip={LineChartTooltip}
      enableGridX={false}
      pointSize={5}
      pointColor={COLORS.COMPANY}
      pointLabelYOffset={-12}
      useMesh={true}
      legends={[]}
      theme={{
        crosshair: {
          line: {
            strokeWidth: 0.5,
            stroke: `${color}`,
          },
        },
        axis: {
          ticks: {
            line: {
              stroke: `${color}70`,
            },
            text: {
              // fill: COLORS.BUTTONS1,
              fill: `${color}70`,
            },
          },
        },
        grid: {
          line: {
            // stroke: COLORS.BORDER,
            stroke: `${color}30`,
            strokeWidth: 0.8,
            strokeDasharray: "4 4",
          },
        },
      }}
      {...props}
    />
    // </div>
  );
}
